import ComputingHero from './computingHero/ComputingHero';
import ComputingWhat from './computingWhat/ComputingWhat';
import ComputingCapability from './computingCapabilty/ComputingCapabilty';
import ComputingBenefits from './computingBenefit/ComputingBenefits';
import ComputingService from './computingService/ComputingService';
import ComputingTestimonial from './computingTestimonial/ComputingTestimonial';
import ComputingStart from './computingStart/ComputingStart';
import ComputingChoose from './computingChoose/ComputingChoose';
import ComputingImplement from './computingImplement/ComputingImplement';

export default function Computing() {
  return (
    <div>
    <ComputingHero/>
    <ComputingWhat/>
    <ComputingCapability/>
    <ComputingBenefits/>
    <ComputingImplement/>
    <ComputingChoose/>
    <ComputingStart/>
    <ComputingTestimonial/>
    <ComputingService/>
    </div>
  )
}
